import { Bundle } from '@ali/visualengine';
import React from 'react';

const CnCardSubCardBundle = Bundle.createPrototype({
  componentName: 'CnCardSubCard',
  title: '子卡片',
  category: null,
  isInline: false,
  isContainer: true,
  canHovering: false,
  canSelecting: false,
  canDropIn: true,
  canDragging: false,
  canDropTo: 'CnCard',
  configure: [
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
  ],
});

export default CnCardSubCardBundle;
